var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "ave__search" }, [
    _vm.results
      ? _c(
          "div",
          { staticClass: "ave__search__results" },
          [
            _vm.results && _vm.results.length === 0
              ? _c("div", [
                  _c("span", { staticClass: "ave__search__result-count" }, [
                    _vm._v(_vm._s(_vm.$t("noResult"))),
                  ]),
                ])
              : [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c(
                          "global-loading-overlay",
                          { attrs: { showLoading: _vm.text_freeze } },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("loading")) +
                                "\n                    "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-12" }, [
                            _c(
                              "span",
                              { staticClass: "ave__search__result-count" },
                              [
                                _vm._v(
                                  _vm._s(_vm.resultCount) +
                                    " " +
                                    _vm._s(_vm.$t("totalResults"))
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "ave__search__results--decoration",
                            }),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "row ave__search__items" },
                          _vm._l(_vm.results, function (product, index) {
                            return _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.page === _vm.groupTiles(index),
                                    expression: "page === groupTiles(index)",
                                  },
                                ],
                                staticClass: "col-6 col-md-3 col-lg-2",
                              },
                              [
                                _c("global-material-tile", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.page === _vm.groupTiles(index),
                                      expression: "page === groupTiles(index)",
                                    },
                                  ],
                                  attrs: { entity: product },
                                }),
                              ],
                              1
                            )
                          }),
                          0
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "ave__pagination" },
                    [
                      _c("span", { staticClass: "pagination__indicator" }, [
                        _vm._v(_vm._s(_vm.decorsShown)),
                      ]),
                      _vm._v(" "),
                      _c("global-button", {
                        staticClass: "ignore-context pagination--prev",
                        class: _vm.page - 1 < _vm.lowerEnd ? "disabled" : "",
                        attrs: { icon: "arrow-left", theme: "secondary" },
                        on: {
                          click: function ($event) {
                            return _vm.changePage(_vm.page - 1, "prev")
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("global-button", {
                        staticClass: "ignore-context pagination--prev",
                        class: _vm.page + 1 > _vm.upperEnd ? "disabled" : "",
                        attrs: { icon: "arrow-right", theme: "secondary" },
                        on: {
                          click: function ($event) {
                            return _vm.changePage(_vm.page + 1, "next")
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }